import { render, staticRenderFns } from "./ContractNewEditDialog.vue?vue&type=template&id=bb99ca0e&scoped=true"
import script from "./ContractNewEditDialog.vue?vue&type=script&lang=js"
export * from "./ContractNewEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ContractNewEditDialog.vue?vue&type=style&index=0&id=bb99ca0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb99ca0e",
  null
  
)

export default component.exports